import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=1cb4ab4a&scoped=true&"
import script from "./OrderError.vue?vue&type=script&lang=js&"
export * from "./OrderError.vue?vue&type=script&lang=js&"
import style0 from "./OrderError.vue?vue&type=style&index=0&id=1cb4ab4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb4ab4a",
  null
  
)

export default component.exports